<script setup>
import { mdiCog } from "@mdi/js";
import { computed,defineProps,defineEmits } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  emptyMessage: {
    type: String,
    default: "Please Upload File…",
  },
  icon: {
    type: String,
    default: null,
  },
  headerIcon: {
    type: String,
    default: null,
  },
  rounded: {
    type: String,
    default: "md:rounded",
  },
  hasTable: Boolean,
  empty: Boolean,
  form: Boolean,
  hoverable: Boolean,
  color: Boolean,
});

const emit = defineEmits(["headerIconClicked", "submit"]);

const is = computed(() => (props.form ? "form" : "div"));

const componentClass = computed(() => {
  const base = [props.rounded];

  if (props.hoverable) {
    base.push(
      "hover:shadow-xl hover:shadow-[#1670ff70] hover:border-[#80808040] transition duration-500 border"
    );
  }
  if (props.color) {
    base.push(
      "md:rounded-md lg:rounded-xl shadow-xl shadow-[#1670ff]/[0.2] bg-gradient-to-br from-[#1670ff20] via-[#1670ff10] to-[#1670ff00]"
    );
  }
  return base;
});

const computedHeaderIcon = computed(() => props.headerIcon ?? mdiCog);

const headerIconClick = () => {
  emit("headerIconClicked");
};

const submit = (e) => {
  emit("submit", e);
};
</script>

<template>
  <component
    :is="is"
    :class="componentClass"
    class="bg-white border border-blue-100 shadow-lg shadow-blue-100 dark:bg-gray-800 dark:border-gray-700 dark:shadow-md dark:shadow-gray-800"
    @submit="submit"
  >
    <header
      v-if="title"
      class="flex items-stretch border-b border-blue-100 dark:border-gray-700"
    >
      <p
        class="flex items-center py-3 flex-grow font-bold"
        :class="[icon ? 'px-4' : 'px-6']"
      >
        <base-icon v-if="icon" :path="icon" class="mr-3" size="20" />
        {{ title }}
      </p>
      <a
        v-if="computedHeaderIcon"
        href="#"
        class="flex items-center py-3 px-4 justify-center ring-blue-700 focus:ring"
        aria-label="more options"
        @click.prevent="headerIconClick"
      >
        <base-icon :path="computedHeaderIcon" size="20" />
      </a>
    </header>
    <div
      v-if="empty"
      class="text-center py-24 text-gray-500 dark:text-gray-400"
    >
      <p>{{ emptyMessage }}</p>
    </div>
    <div v-else :class="{ 'p-6': !hasTable }">
      <slot />
    </div>
  </component>
</template>
